import { pdfjs } from "react-pdf";

import { getMobileOs, isSafari } from "../../../utilities/userAgentHelper";

/*
https://github.com/wojtekmaj/react-pdf/tree/main?tab=readme-ov-file#browser-support
https://github.com/wojtekmaj/react-pdf/issues/1811
https://github.com/wojtekmaj/react-pdf/issues/2026
*/

let isModernPdfJsBuildSupported = true;

// @ts-expect-error Polyfill for Promise
if (typeof Promise.withResolvers !== "function") {
  isModernPdfJsBuildSupported = false;
  // @ts-expect-error Polyfill for Promise
  window.Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

if (typeof URL.parse !== "function") {
  isModernPdfJsBuildSupported = false;

  window.URL.parse = function (url: string | URL, base?: string | URL | undefined) {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

const promiseTryForwardsArguments = () => {
  let forwarded = false;
  // @ts-expect-error Polyfill for Promise
  Promise.try?.((arg: boolean) => {
    forwarded = arg;
  }, true);
  return forwarded;
};

// PDF.js passes its stream sink as a Promise.try argument, so an injected Promise.try that drops arguments breaks every load.
if (!promiseTryForwardsArguments()) {
  // @ts-expect-error Polyfill for Promise
  window.Promise.try = (fn: (...args: unknown[]) => unknown, ...args: unknown[]) =>
    new Promise((resolve) => resolve(fn(...args)));
}

// PDF.js lists Safari support under the legacy build:
// https://github.com/mozilla/pdf.js/wiki/Frequently-Asked-Questions#which-browsersenvironments-are-supported
// iOS browsers are WebKit-backed.
const shouldUseLegacyPdfJsBuild = () => !isModernPdfJsBuildSupported || isSafari() || getMobileOs() === "iOS";

export const getPdfJsWorkerBuild = (): "legacy" | "modern" => (shouldUseLegacyPdfJsBuild() ? "legacy" : "modern");

export const initPdfViewer = () => {
  pdfjs.GlobalWorkerOptions.workerSrc =
    getPdfJsWorkerBuild() === "legacy"
      ? new URL("pdfjs-dist/legacy/build/pdf.worker.min.mjs", import.meta.url).toString()
      : new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();
};
